module.exports = __webpack_public_path__ + "static/media/12UNCTAD4.752c3691.jpg";